import {IczRoutes} from '@icz/angular-application-core';
import {SettledDocumentsComponent} from './settled-documents.component';

export const ROUTES: IczRoutes = [{ path: '', component: SettledDocumentsComponent }];
